export const categories = [
  {
    id: "ent",
    name: "娱乐圈",
    desc: "行程、通告、片场与经纪公司之间的那些事。",
    icon: "ri-movie-2-line",
    count: 3420,
    accent: "primary",
  },
  {
    id: "wanghong",
    name: "网红圈",
    desc: "直播、带货、签约解约与流量生意背后的账本。",
    icon: "ri-live-line",
    count: 2186,
    accent: "accent",
  },
  {
    id: "business",
    name: "商业内幕",
    desc: "融资、供应链、门店扩张与品牌公关的暗面。",
    icon: "ri-line-chart-line",
    count: 1745,
    accent: "secondary",
  },
  {
    id: "workplace",
    name: "职场爆料",
    desc: "大厂、创业公司与办公室里被压下去的规则。",
    icon: "ri-briefcase-4-line",
    count: 1502,
    accent: "primary",
  },
  {
    id: "campus",
    name: "校园瓜",
    desc: "评奖、竞赛、社团与宿舍里那些说不清的事。",
    icon: "ri-graduation-cap-line",
    count: 986,
    accent: "secondary",
  },
  {
    id: "life",
    name: "生活八卦",
    desc: "邻里、亲友、小区群里真实又离谱的日常。",
    icon: "ri-cup-line",
    count: 1327,
    accent: "accent",
  },
];

export const articles = [
  {
    id: "top-star-studio-comeback",
    title: "顶流男歌手深夜独自现身录音棚，复出专辑疑似进入收尾阶段",
    excerpt:
      "连续三个晚上被拍到深夜进出同一间录音棚，随行只带一名助理。有棚内工作人员透露，专辑已经录到第九首，混音团队也已经进场。",
    category: "娱乐圈",
    categoryId: "ent",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20moody%20recording%20studio%20scene%20with%20warm%20amber%20and%20crimson%20spotlights%2C%20silhouette%20of%20a%20studio%20microphone%20and%20blurred%20neon%20glow%2C%20stylized%20editorial%20illustration%2C%20cinematic%20high%20contrast%2C%20no%20text&width=1200&height=800&seq=gy-hub-hero-01&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-09",
    updated: "2026-09-10",
    views: 128436,
    comments: 862,
    heat: 98,
    featured: true,
    breaking: true,
    tags: ["复出", "录音棚", "新专辑"],
    content: [
      "近一周里，连续三个深夜都有路人在同一栋写字楼外拍到他的车。时间点都在凌晨一点前后，副驾驶几乎没有坐人，随行的只有一名跟了很多年的助理。",
      "这栋楼里有三家音乐制作公司，其中一家在月初刚刚完成设备升级。有棚内工作人员提到，近期的排期表上连续九天的同一时段都被占满，混音团队也已经在第二周进场，节奏看起来像是专辑进入收尾。",
      "值得注意的是，他上一次公开露面还是两年前的品牌活动。期间社交账号停更、商务合作归零，团队对外只回应过一句『在休息』。如今突然密集进出录音棚，让复出的猜测有了具体的落点，但截至目前，其经纪方并未对拍摄内容作出回应。",
      "有接近制作方的人士表示，专辑目前仍处在母带处理前的最后阶段，正式发行时间尚未敲定。是否由原公司发行，也还在谈。",
    ],
  },
  {
    id: "head-livestream-slap",
    title: "头部主播直播翻车：口中的“全网最低价”，被扒出是贴牌库存货",
    excerpt:
      "一场 GMV 破亿的专场结束后，有买家发现商品与外包装标注的生产厂家对不上，同款在批发平台的采购价不到直播价的三分之一。",
    category: "网红圈",
    categoryId: "wanghong",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20livestream%20shopping%20scene%20in%20warm%20amber%20and%20crimson%20tones%2C%20stylized%20illustration%20of%20a%20ring%20light%20and%20stacked%20parcel%20boxes%20with%20soft%20glow%2C%20editorial%20magazine%20style%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-11&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-07",
    updated: "2026-09-09",
    views: 96420,
    comments: 1204,
    heat: 94,
    featured: true,
    breaking: false,
    tags: ["直播带货", "贴牌", "库存货"],
    content: [
      "问题出在包装背面的生产厂家。有买家把实物照片和页面详情做了比对，发现两处标注的企业名称完全对不上，其中一家在去年就已经注销了食品相关资质。",
      "更让买家意外的是同款商品在批发平台的报价。同一个外观、同一个规格，批量采购单价不到直播间价格的三分之一，而直播间反复强调的『全网最低价』，恰恰是这场专场最核心的卖点。",
      "团队目前给出的说法是『供应商临时更换了包装』，但并未解释为何更换后仍沿用原厂信息。平台方面表示已收到消费者反馈，正在按流程核实商品资质。",
    ],
  },
  {
    id: "agency-copy",
    title: "同一家经纪公司两套通稿被扒：给 A 的说法和给 B 的说法完全对不上",
    excerpt:
      "两份几乎同时发出的说明稿，一份强调“档期冲突”，另一份写的是“双方友好协商”，而时间线里两人当天的行程其实是重叠的。",
    category: "娱乐圈",
    categoryId: "ent",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20two%20overlapping%20document%20pages%20with%20warm%20amber%20borderlight%20on%20a%20soft%20crimson%20backdrop%2C%20minimal%20magazine%20composition%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-12&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-06",
    updated: "2026-09-06",
    views: 74210,
    comments: 638,
    heat: 90,
    featured: false,
    breaking: false,
    tags: ["经纪公司", "通稿", "时间线"],
    content: [
      "两份说明稿的发布时间只差了四十分钟，落款是同一家公司，措辞却像出自两个不同的团队。一份把原因归结为档期冲突，另一份则强调双方是友好协商后各自独立发展。",
      "对照公开行程可以发现，两份稿子里提到的档期说法本身就有矛盾。被指档期冲突的那一天，两人的行程在同一个城市、同一时段还有重叠。",
      "截至发稿，公司方面未就两份稿件的差异作出解释。有业内人士认为，这类情况通常出现在内部两位艺人共用同一个宣传团队的阶段。",
    ],
  },
  {
    id: "new-brand-debt",
    title: "新锐饮品品牌被曝拖欠供应商货款，多地门店悄悄换招牌",
    excerpt:
      "有供应商称货款已经拖欠超过三个月，催款群里的人数还在增加；与此同时，几个核心商圈的店铺正在深夜摘下原来的门头。",
    category: "商业内幕",
    categoryId: "business",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20an%20empty%20storefront%20shelf%20with%20warm%20amber%20lighting%20and%20deep%20olive%20shadows%2C%20minimal%20magazine%20style%2C%20quiet%20melancholy%20mood%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-13&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-05",
    updated: "2026-09-08",
    views: 61330,
    comments: 412,
    heat: 88,
    featured: true,
    breaking: false,
    tags: ["拖欠货款", "门店", "供应链"],
    content: [
      "最先发现问题的是给品牌供应杯材的小厂。对方说，从六月开始结算周期就被一拖再拖，到八月已经累计超过三个月的货款，理由是『财务系统升级』。",
      "催款群的人数在两个月里从十几个人涨到了七十多个，涉及杯材、糖浆、冷链与装修等环节。有供应商已经停止发货，门店的部分原料因此出现断供。",
      "与此同时，几个核心商圈的店铺正在夜间更换门头。有附近商户表示，换招牌的施工都在闭店后进行，白天看起来并无变化。品牌方截至目前尚未公开回应。",
    ],
  },
  {
    id: "office-manager-secret",
    title: "大厂中层被下属集体举报：把项目奖金池当私人钱包用了两年",
    excerpt:
      "举报材料里附了一张手写分配表，同一个项目节点的奖金，被拆成两笔发放，一笔走系统，一笔走线下。",
    category: "职场爆料",
    categoryId: "workplace",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20an%20empty%20open%20plan%20office%20desk%20at%20night%20with%20warm%20amber%20desk%20lamp%20and%20deep%20olive%20shadows%2C%20minimal%20magazine%20composition%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-14&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-04",
    updated: "2026-09-07",
    views: 58940,
    comments: 530,
    heat: 85,
    featured: false,
    breaking: false,
    tags: ["奖金池", "团队管理", "举报"],
    content: [
      "图片里的手写表只有 A4 纸大小，但列得很清楚：项目节点、应发金额、实发金额、差额。多名同组员工核对后确认，差额部分并没有出现在任何一次公示里。",
      "据反映，这种拆分方式已经持续了两年。走的系统那笔有完整记录，走线下的那笔则通过部门经费报销，名目是『团建与激励』。",
      "有员工在今年年中提出质疑，随后被调整了汇报关系。目前公司内部审计部门已经介入，但尚未公布结论，涉事员工也暂未被停职。",
    ],
  },
  {
    id: "mcn-contract",
    title: "MCN 机构解约潮背后：签约合同里那条被忽略的“三倍赔偿”条款",
    excerpt:
      "十几位达人先后申请解约，理由几乎一致；而机构给出的回复也都指向同一份合同里的同一行小字。",
    category: "网红圈",
    categoryId: "wanghong",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20signed%20contract%20page%20with%20warm%20amber%20highlight%20and%20crimson%20wax%20seal%2C%20deep%20olive%20backdrop%2C%20minimal%20magazine%20style%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-15&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-03",
    updated: "2026-09-03",
    views: 49180,
    comments: 386,
    heat: 83,
    featured: false,
    breaking: false,
    tags: ["MCN", "解约", "合同条款"],
    content: [
      "矛盾的起点是收益分成比例调整。达人们表示，调整前后自己拿到手的比例下降了近一半，而机构认为这是合同里明确约定的『运营成本浮动机制』。",
      "真正让解约卡住的，是合同末尾单独成段的一条：提前解约需按已获收益的三倍进行赔偿。多位达人称，签约时这条被解释为『行业标准模板，不会真的执行』。",
      "目前已有律师介入，认为该条款在部分情况下可能构成显著失衡。机构方面表示一切以合同为准，并拒绝进一步回应。",
    ],
  },
  {
    id: "campus-scholarship",
    title: "高校奖学金名单被质疑：同一份竞赛奖项出现在六个学院的申报表里",
    excerpt:
      "名单公示当天就有学生在群里发现，同一个奖项编号被重复使用了六次，而对应的指导老师姓名也各不相同。",
    category: "校园瓜",
    categoryId: "campus",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20piled%20application%20forms%20on%20a%20wooden%20desk%20with%20warm%20amber%20lamp%20light%20and%20deep%20olive%20shadows%2C%20minimal%20academic%20mood%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-16&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-02",
    updated: "2026-09-06",
    views: 43260,
    comments: 297,
    heat: 79,
    featured: false,
    breaking: false,
    tags: ["奖学金", "竞赛", "公示"],
    content: [
      "公示表按学院分栏，把六个学院的表格放在一起就很容易看出问题：同一个竞赛的奖项编号反复出现，而申报人分属不同学院、不同年级。",
      "有学生按编号去查赛事官网，发现该奖项当年只产生了一个获奖名额，且归属于校外一支队伍。也就是说，至少五份申报材料的奖项归属存在疑问。",
      "学校方面回应称已注意到相关反馈，评审委员会将对该批次材料进行复核，复核期间名单暂不生效。",
    ],
  },
  {
    id: "startup-founder",
    title: "融资发布会刚结束，创始人就被投资人追问：那笔钱到底花在哪了",
    excerpt:
      "台上还在合影，台下已经在翻财务表。据在场人士说，追问的核心是市场费用与研发投入的比例。",
    category: "商业内幕",
    categoryId: "business",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20stage%20podium%20with%20warm%20amber%20spotlight%20and%20fading%20crimson%20gradient%2C%20empty%20audience%20seats%20in%20deep%20olive%20shadow%2C%20minimal%20magazine%20style%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-17&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-09-01",
    updated: "2026-09-01",
    views: 37610,
    comments: 214,
    heat: 76,
    featured: false,
    breaking: false,
    tags: ["融资", "市场费用", "研发投入"],
    content: [
      "发布会流程走得很顺，签约、合影、媒体采访一样没落。变化出现在合影之后的闭门环节，几位投资方直接拿出了近两个季度的支出明细。",
      "据在场人士描述，追问集中在两处：市场费用为何连续两个季度占到总支出的六成以上，以及研发团队的实际到岗人数与对外披露的规模是否一致。",
      "创始团队的回应是『投放换增长在预期之内』，但并未当场给出具体的调整方案。后续是否有新的资金进入，目前仍是未知数。",
    ],
  },
  {
    id: "couple-apartment",
    title: "小区业主群炸了：对门两家为一个快递柜吵到整栋楼围观的真相",
    excerpt:
      "表面争的是一个快递柜的摆放位置，实际上牵扯出的是两年前那笔一直没结清的装修尾款。",
    category: "生活八卦",
    categoryId: "life",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20a%20quiet%20apartment%20corridor%20at%20dusk%20with%20warm%20amber%20door%20lights%20and%20olive%20shadows%2C%20cozy%20everyday%20mood%2C%20minimal%20style%2C%20no%20text&width=800&height=600&seq=gy-hub-cover-18&orientation=landscape",
    author: "匿名瓜友",
    date: "2026-08-30",
    updated: "2026-08-31",
    views: 29480,
    comments: 176,
    heat: 72,
    featured: false,
    breaking: false,
    tags: ["邻里", "装修尾款", "业主群"],
    content: [
      "事情的引子很小：楼道里多了一个快递柜，占了原本放鞋架的位置。两家在业主群里从沟通变成互相指责，只用了一个晚上。",
      "转折出现在第二天早上。楼下一位老邻居私聊了双方，说两年前其中一家的装修队把楼道墙面和公共电表箱碰坏了，当时答应维修的尾款一直没结，双方就是从那时候结下的疙瘩。",
      "快递柜最后被挪回了物业指定位置，两家也各自删掉了群里的长语音。至于尾款，据说是物业出面牵了个头，双方约定月底前把账结清。",
    ],
  },
];

export const featuredArticleIds = ["top-star-studio-comeback"];

export const trendingArticleIds = [
  "top-star-studio-comeback",
  "head-livestream-slap",
  "agency-copy",
  "new-brand-debt",
  "office-manager-secret",
  "mcn-contract",
];